import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    FormHelperText,
    TextField,
    Typography,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';
import FieldHelpHint from '../../FieldHelpHint';
import Iconify from '../../Iconify';
import { setMachineDetailsData } from '../../../redux/machineDetailsDataSlice';
import { setSuccessfullModifyDialog } from '../../../redux/successfullModifyDialogSlice';
import { CustomErrorLogger } from '../../../utils/CustomErrorLogger';
import {
    EVAL_UTILISATION_HELP_TEXT,
    EVAL_UTILISATION_TITLE,
} from '../evalUtilisationHelpContent';
import '../../../css/machines/modifierEvalUtilisation.css';

const urlSchema = Yup.string()
    .trim()
    .nullable()
    .test('is-url-or-empty', 'URL invalide (ex. https://docs.google.com/forms/...)', (value) => {
        if (!value) {
            return true;
        }
        try {
            const parsed = new URL(value);
            return ['http:', 'https:'].includes(parsed.protocol);
        } catch {
            return false;
        }
    });

export const ModifierEvalUtilisation = ({ modifyEvalUtilisation, setModifyEvalUtilisation }) => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const machineDetailsData = useSelector((state) => state.MachineDetailsData);

    const formik = useFormik({
        initialValues: {
            eval_utilisation_url: machineDetailsData?.eval_utilisation_url || '',
        },
        validationSchema: Yup.object().shape({
            eval_utilisation_url: urlSchema,
        }),
        onSubmit: async (values) => {
            try {
                const payload = {
                    eval_utilisation_url: values.eval_utilisation_url?.trim() || '',
                };
                const response = await axios.patch(`machine/eval_utilisation/${id}`, payload);
                if (response.status === 200 || response.status === 201) {
                    dispatch(setSuccessfullModifyDialog({
                        open: true,
                        type: 'Modifier l\'évaluation d\'utilisation',
                    }));
                    dispatch(setMachineDetailsData({
                        ...machineDetailsData,
                        eval_utilisation_url: response.data.eval_utilisation_url,
                    }));
                    setModifyEvalUtilisation(false);
                }
            } catch (error) {
                console.error('Error updating eval utilisation URL:', error);
                CustomErrorLogger(error, 'Error updating eval_utilisation_url in ModifierEvalUtilisation');
            }
        },
    });

    const { handleSubmit, values, handleBlur, touched, errors, handleChange } = formik;

    return (
        <Dialog open={modifyEvalUtilisation} fullWidth maxWidth="sm">
            <Box onClick={() => setModifyEvalUtilisation(false)} className="modifierEvalUtilisation_icon_text">
                <Typography className="modifierEvalUtilisation_title">
                    Modifier l&apos;évaluation d&apos;utilisation
                </Typography>
                <Iconify icon="material-symbols:close" className="modifierEvalUtilisation_close_icon" />
            </Box>
            <form onSubmit={handleSubmit}>
                <DialogContent className="modifierEvalUtilisation_dialog_content">
                    <Box className="modifierEvalUtilisation_label_row">
                        <FormHelperText className="modifierEvalUtilisation_helper_text">
                            {EVAL_UTILISATION_TITLE}
                        </FormHelperText>
                        <FieldHelpHint title={EVAL_UTILISATION_TITLE}>
                            {EVAL_UTILISATION_HELP_TEXT}
                        </FieldHelpHint>
                    </Box>
                    <TextField
                        fullWidth
                        name="eval_utilisation_url"
                        value={values.eval_utilisation_url}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder="https://docs.google.com/forms/..."
                        error={touched.eval_utilisation_url && Boolean(errors.eval_utilisation_url)}
                        helperText={touched.eval_utilisation_url && errors.eval_utilisation_url}
                        className={
                            values.eval_utilisation_url
                                ? 'modifierEvalUtilisation_input filledField'
                                : 'modifierEvalUtilisation_input'
                        }
                    />
                </DialogContent>
                <DialogActions className="modifierEvalUtilisation_dialog_actions">
                    <Button
                        className="modifierEvalUtilisation_button_annuler"
                        onClick={() => setModifyEvalUtilisation(false)}
                    >
                        Annuler
                    </Button>
                    <Button
                        className="modifierEvalUtilisation_button_valider"
                        variant="contained"
                        type="submit"
                    >
                        Valider
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};
